import { render, staticRenderFns } from "./notesSmall.vue?vue&type=template&id=f009da16&scoped=true&"
import script from "./notesSmall.vue?vue&type=script&lang=js&"
export * from "./notesSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f009da16",
  null
  
)

export default component.exports